$(document).on('click','.MobileMenusLine',function(){
    $('body').toggleClass('scrolloff');
    $('html').toggleClass('scrolloff');
    $('.ForMobileMenu').toggleClass('active');
    $(this).toggleClass('active');
    //$('.submenusData').toggleClass('active');
    if(!$(this).hasClass('active')){
        
            $('.submenusData').removeClass('active');
        
    }
});

$(document).on('click','.closeicons',function(){
    $(this).parents('.submenusData').removeClass('active');
});
$(document).on('click','.SubmenusBg .submenu .submenu-item',function(){
    $('.SubmenusBg .submenu .submenu-item').removeClass('active');
    $(this).addClass('active');
});


$(document).on('click','.filterbuns',function(){
    $('.filterOptions').toggleClass('active');
});